


























import Vue from 'vue';
import massVuex from '../../vuex/common';
import massClient from '../../apis';
import MassNewsItem from './MassNewsItem.vue';

export default Vue.extend({
  mixins: [massVuex],
  components: {
    MassNewsItem,
  },
  data() {
    return  {
      loaded: false,
      massNews: null,
    };
  },
  props: {
    task: {
      type: Object,
    },
  },
  methods: {
    getMassNewsStat() {
      massClient.getMassNewsStat({id: this.task.id}).success((r) => {
        this.massNews = r.data;
        this.loaded = true;
      });
    },
  },
  mounted() {
    this.getMassNewsStat();
  },
});
